import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import {
    AccountContentStyled,
    AccountHeaderBonusContainer,
    AccountHeaderLogoStyled,
    AccountHeaderMenuStyled,
    AccountHeaderStyled,
    AccountStyled,
    AccountZendeskButtonWrapper
} from "./styled/AccountStyled.js";
import { Button } from "react-bootstrap";
import { openModalAction } from "../../../app/appActions.js";
import LogoComponent from "../../../components/LogoComponent/LogoComponent.jsx";
import { useResponsive } from "../../../components/responsive";
import { BinIcon } from "../../../components/icon/Icon.jsx";
import { ZendeskButton } from "../../Zendesk/components/ZendeskButton";
import ProfileButton from "./ProfileButton/ProfileButton";
import WatchVideoLaterTooltip from "../../Tutorials/components/WatchVideoLaterTooltip/WatchVideoLaterTooltip";
import { getIsFirstShowIntro } from "../../Tutorials/tutorialsSelectors";
import { useCallback, useEffect } from "react";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import { BonusTitle } from "../../Bonus/components/BonusTitle.jsx";
import { setWelcomeApplyBonusAction } from "../../Bonus/bonusesActions";
import { MODALS_NAME } from "../../Modals/modalsConstants";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";
import { getUserHasLiveAccount } from "../../../app/appSelectors.js";

function AccountWrapper(props) {
    const {isSmallMaxWidth} = useResponsive();
    const {getLangPath} = useLangContext();
    const {handleGTMClickLogoButton, handleGTMClick, pushGtmEvent} = useGTMEvent({module: 'Header'});
    const {
        hasLiveAccount,
        isFirstShowIntro,
        openModal,
        setApplyBonus,
    } = props;
    useEffect(() => {
        if (isFirstShowIntro) {
            openModal(MODALS_NAME.INTRO)
        }
    }, [isFirstShowIntro, openModal])

    const handleBonusTitleClick = useCallback(() => {
        setApplyBonus(true);
        openModal({name: MODALS_NAME.CASHIER, tab: 'deposit'});
        pushGtmEvent({event: 'bannerClick', banner: 'FirstDepositBonusBanner'})
    }, [setApplyBonus, openModal, pushGtmEvent]);

    const handleDepositClick = useCallback(() => {
        openModal({name: MODALS_NAME.CASHIER, tab: 'deposit'});
        handleGTMClick({button: 'Deposit'})
    }, [openModal, handleGTMClick]);

    const handleWithdrawClick = useCallback(() => {
        openModal({name: MODALS_NAME.CASHIER, tab: 'withdraw'})
        handleGTMClick({button: 'Withdraw'})
    }, [openModal, handleGTMClick]);

    return <AccountStyled>

        <AccountHeaderStyled>
            <AccountHeaderBonusContainer>
                <BonusTitle onClick={handleBonusTitleClick} style={{borderRadius: '0 0 4px 4px'}}/>
            </AccountHeaderBonusContainer>
            <AccountHeaderLogoStyled isSmallMaxWidth={isSmallMaxWidth}>
                <LogoComponent onClick={handleGTMClickLogoButton}/>
            </AccountHeaderLogoStyled>

            <AccountHeaderMenuStyled>
                {
                    hasLiveAccount && <>
                        {
                            isSmallMaxWidth ? <>
                                <Button variant={'primary'}
                                        size={'sm'}
                                        onClick={handleDepositClick}><BinIcon
                                    name={'IcTrades'}/></Button>
                            </> : <>
                                <Button variant={'primary'}
                                        size={'sm'}
                                        onClick={handleDepositClick}
                                        className="me-2"
                                >{getLangPath('menu.deposit')}</Button>
                                <Button variant={'info'}
                                        size={'sm'}
                                        onClick={handleWithdrawClick}>{getLangPath('menu.withdraw')}</Button>
                            </>
                        }
                    </>
                }
                <AccountZendeskButtonWrapper>
                    <ZendeskButton iconFontSize="20px"/>
                </AccountZendeskButtonWrapper>
                <WatchVideoLaterTooltip>
                    <ProfileButton/>
                </WatchVideoLaterTooltip>

            </AccountHeaderMenuStyled>

        </AccountHeaderStyled>

        <AccountContentStyled>
            {props.children}
        </AccountContentStyled>

    </AccountStyled>
}

const mapStateToProps = createStructuredSelector({
    hasLiveAccount: getUserHasLiveAccount,
    isFirstShowIntro: getIsFirstShowIntro,
});

const mapDispatchToProps = (dispatch) => ({
    setApplyBonus: (payload) => dispatch(setWelcomeApplyBonusAction(payload)),
    openModal: (payload) => dispatch(openModalAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountWrapper);
